import { NgFor, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { DialogService } from '@core-components/dialog/service/dialog.service';
import { EventsService } from '@services/events/events.service';
import { environment } from '@environment';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { StorageService } from '@services/storage/storage.service';
import { MatIconModule } from '@angular/material/icon';
import { ButtonComponent } from '@common-components/button/button.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-onboarding-v2',
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    MatIconModule,
    ButtonComponent,
    RouterModule
  ],
  templateUrl: './onboarding-v2.component.html',
  styleUrls: ['./onboarding-v2.component.scss']
})
export class OnboardingV2Component {

  readonly vars = inject(VariablesService);
  readonly util = inject(UtilService);
  private readonly storage = inject(StorageService);
  private events = inject(EventsService);
  private dialogService = inject(DialogService);

  isMobile = this.vars.isMobile;
  sipRetentionUrl;
  isLoggedIn = false;
  platform;

  info = {
    mainTitle: 'Welcome to <br> Monthly Giving',
    desc: 'You are now part of a community of 33k+ contributors who are dedicated to saving lives every month',
    boxes: [
      { id: 1, title: 'Personalized Contributor Dashboard', imgName: 'your-impact-thankyou' },
      { id: 2, title: 'Avail Exclusive Rewards', imgName: 'reward-thankyou' },
      { id: 3, title: 'Faster Contribution Updates', imgName: 'updates-thankyou' },
      { id: 4, title: 'Allocate Funds Easily', imgName: 'fund-alloc-thankyou' }
    ],
    sendLinkSection: {
      mainText: 'Enter your Mobile number to recieve an app download link',
    }
  };

  ngOnInit() {
    this.util.addCssToGlobal('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Poppins:wght@400;600;700&display=swap');
    this.vars.layoutConfig.next({
      showFooter: false,
      showHeader: this.vars.isMobile ? false : true,
      headerTopSticky: false,
      showMenus: false
    });
    this.sipRetentionUrl = environment.sipretention_domain;
    if (this.vars.utmsUrlString) {
      this.sipRetentionUrl += '?' + this.vars.utmsUrlString;
    }
    this.checkIsUserLoggedIn();
    this.platform = this.storage.getCookie('platform');
    this.systemEventHandler('pageView');
  }

  ngAfterViewInit() {
    this.dialogService.closeDialog();
  }

  checkIsUserLoggedIn() {
    const user = this.util.getUser();
    if (user && user.user) {
      this.isLoggedIn = user.user.isLoggedIn;
    } else {
      this.isLoggedIn = false;
    }
  }


  systemEventHandler(eventName) {
    const payload = {
      eventName,
      event_type: 'onboarding',
      page_name: 'onboarding-d0',
      info_1: 'onboarding-new',
      info_2: ''
    };

    this.events.onLoadSystemEvent(payload);
  }
}
